export default __webpack_public_path__ + "static/media/02-main.57fc16b5.jpg";